
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { AppConfig } from './app.config';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  public coursesFlag: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public dialogFlag: BehaviorSubject<string> = new BehaviorSubject<string>('');
  public resultScroll:  BehaviorSubject<string> = new BehaviorSubject<string>('');
  public footerData: BehaviorSubject<string> = new BehaviorSubject<string>('');

      constructor(public http: HttpClient, public AppConfig: AppConfig) { }
 saveCourseFlag(data: any) {
    this.coursesFlag.next(data)
  }
    saveDialog(data: any) {
    this.dialogFlag.next(data)
  }

   getProfile(token: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token
      })
    };

    return this.http.get(this.AppConfig.LOGIN_ENDPOINT + 'user_get', httpOptions)
      .pipe(map((response: any) => response));
  }
   addCallClickData(reqData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': '6669ac7eeb6f363a778463e0',
        "orgid": "66dec57ce200bc89284602d6",
        "uid": '66dec57ce200bc89284602d6',
      })
    };

    return this.http.post('https://crm-api-prod.iquanta.in/api/v1/org/product/entity/counter/update', reqData, httpOptions)
      .pipe(map((response: any) => response));
  }
   saveResultScroll(data:any){
    this.resultScroll.next(data)
  }

    saveScroll(val: any) {
    this.footerData.next(val)
  }

   getAllFooterNotifications() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
         
      })
    };

    return this.http.get(this.AppConfig.API_ENDPOINT + 'FooterGet', httpOptions)
      .pipe(map((response: any) => response));
  }

}